import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';

export let updateTimeZones = action('updateSelectedDate')(function updateSelectedDate(
    timeZones: string[],
    store: CalendarSurfaceStore
) {
    store.timeZoneIds = timeZones;
});
